/* eslint-disable max-len */
import React, { useState,useContext } from 'react'
import OrganizationTable from './OrganizationTable'
import SubdivisionDropdownWithSearch from '../SubdivisionDropdown'
import OrganizationDropdownWithSearch from '../DropdownWithSearch'
import Emptyscreenwithouttitle from '../../../../components/Emptyscreenwithouttitle'
import CustomOverLay from '../../../../components/CustomOverLay'
import GlobalContext from '../../../../components/Context/GloablContext';


const ProviderOrganizationAssocaition = ({organizationData,
    organizationFetching, 
    handleOrganizationListSearch,
    organizationListSearch,
    handleFetchSubdivision,
    subdivisionData,
    result,
    setSelectedSubdivisionName,
    handleSubdivisionListSearch,
    selectedOrganizationName,
    handleAddAssociation,
    associatedOrganizations,
    selectedSubdivisionName,
    isOpen,
    setisOpen,
    setisOpensub,
    isOpensub,
    limit,
    subdivisionloadingstatus,
    setLimit,
    handleNoOfRowsClick,
    handleOnClickPageNumber,
    isColumnSelect,
    setIsColumnSelect,
    isOpenLimit,
    setIsOpenLimit,
    handlePrevClick,
    handleNextClick,
    fetchPageAndLimit,
    totalPageNumber,
    setSearchParams,
    handleDeleteAssociatedOrganization,
    setLinkOrganizationModel,
    handleSelectionSubdivision,
    setSelectedOrganizationName,
    isMonitor,
    addObserver,
    selectedPatient,
    linkOrganizationModel,
    showPatientList,
    setShowPatientList,
    setOrgDetails,
}) => {
    const {  isSideBar } = useContext(GlobalContext);
    const [isFirstTimeFeching,setIsFirstTimeFetching] =useState(true)
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })
    return (
        <div className={`${addObserver ? 'w-full ' :'bg-[#00000008] rounded-[8px] p-[12px'}`}>
            <div className={`${addObserver ? '-mx-3' : 'w-full'} flex mb-5`}>
                <div className={`${addObserver ? "px-3 w-1/3" : "xl:px-[18px] pl-2 xl:w-1/3 w-1/2"}`}>
                    <OrganizationDropdownWithSearch
                        label={"Organization Name"}
                        organizationListSearch={organizationListSearch}
                        setSearchParams={setSearchParams}
                        id={`organization_name`}
                        placeholder={'Select organization name'}
                        disabled={addObserver&&selectedPatient?.patient_id!==''&&linkOrganizationModel!==true}
                        value={organizationListSearch.search || ''}
                        organizationData={organizationData}
                        organizationFetching={organizationFetching}
                        handleOrganizationListSearch={handleOrganizationListSearch}
                        handleFetchSubdivision={handleFetchSubdivision}
                        selectedOrganizationName={selectedOrganizationName}
                        setisOpen={setisOpen}
                        isOpen={isOpen}
                        setisOpensub={setisOpensub}
                        optionId={"option_organization_name"}
                        isMonitor={isMonitor}
                        addObserver={addObserver}
                        isFirstTimeFeching={isFirstTimeFeching}
                        setIsFirstTimeFetching={setIsFirstTimeFetching}
                    />
                </div>
                <div className={`${addObserver ? "px-3 w-1/3" : "xl:px-[18px] pl-2 xl:w-1/3 w-1/2"}`}>
                    <SubdivisionDropdownWithSearch
                        label={"Sub Division Name"}
                        placeholder={'Select sub division name'}
                        id={`sub_division_name`}
                        subdivisionData={subdivisionData}
                        result={result}
                        disabled={selectedOrganizationName.organization_name === '' || selectedOrganizationName.organization_name === undefined||(addObserver!==undefined&&selectedPatient?.patient_id!==''&&linkOrganizationModel!==true) ? true : false}
                        handleSubdivisionListSearch={handleSubdivisionListSearch}
                        handleAddAssociation={handleAddAssociation}
                        selectedOrganizationName={selectedOrganizationName}
                        selectedSubdivisionName={selectedSubdivisionName}
                        setisOpensub={setisOpensub}
                        isOpensub={isOpensub}
                        handleSelectionSubdivision={handleSelectionSubdivision}
                        setSelectedOrganizationName={setSelectedOrganizationName}
                        subdivisionloadingstatus={subdivisionloadingstatus}
                        isMonitor={isMonitor}
                        setSelectedSubdivisionName={setSelectedSubdivisionName}
                        addObserver={addObserver}
                        isFirstTimeFeching={isFirstTimeFeching}
                        setIsFirstTimeFetching={setIsFirstTimeFetching}
                    />
                </div>
                {!addObserver &&
                    <div>
                        <button type='button'
                            id={`${isMonitor===undefined?'Add user':'link_organization'}`}
                            className={`py-2.5 px-4 mt-[20px] flex items-center text-lg font-normal border border-[#972E4C] text-[#972E4C] rounded-[16px] ml-2.5 
                        bg-[#fff] disabled:opacity-50 min-w-max`}
                            onClick={() => {setisOpen(false),setLinkOrganizationModel(true),setisOpensub(false)}}
                            disabled={!selectedSubdivisionName.length}
                        >
                            <span className="mr-2.5"><img src="/images/add-plus-red.svg" alt="img" /></span>
                            Link Organization
                        </button>  
                    </div>
                }
                
            </div>
        
            { !addObserver &&
                <div>
                    {((result.status !== "fulfilled" && result.status !== "rejected") || (result === undefined && result.status !== "fulfilled" && result.status !== "rejected")) ?
                        <CustomOverLay Active text="Loading Organization list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? isMonitor?'opened_sidebar_overlay3':'opened_sidebar_overlay2' : isMonitor?'overlay-list3':'overlayProvider-list2'}`} /> : <>
                            <OrganizationTable
                                hoverProperties={hoverProperties} 
                                setHoverProperties={setHoverProperties} 
                                associatedOrganizations={associatedOrganizations}
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                isColumnSelect={isColumnSelect}
                                setIsColumnSelect={setIsColumnSelect}
                                isOpenLimit={isOpenLimit}
                                setIsOpenLimit={setIsOpenLimit}
                                handlePrevClick={handlePrevClick}
                                handleNextClick={handleNextClick}
                                fetchPageAndLimit={fetchPageAndLimit}
                                totalPageNumber={totalPageNumber}
                                result={result}
                                setisOpen={setisOpen}
                                setisOpensub={setisOpensub}
                                handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                isMonitor={isMonitor}
                                showPatientList={showPatientList}
                                setShowPatientList={setShowPatientList}
                                setOrgDetails={setOrgDetails}
                                setSelectedSubdivisionName={setSelectedSubdivisionName}
                            />
                        </>}
                </div>
            }
        </div>
    )
}

export default ProviderOrganizationAssocaition